import { SET_MONTH_YEAR, RESET_MONTH } from "../actions/types";
var d = new Date();
var n = d.getFullYear();
var month = d.getMonth() + 1;
var day = d.getDate();
// var month = 1;
// var day = 1;
let mmonth;



 if ((month == 1 && day < 11)) {
  month = 12;
  n = n - 1;
}
else if ((month == 1 && day >= 10)) {
  month = 1;
  // n = n - 1;
}
else if (month < 12 && day < 11) {
  month = month - 1;
} else if (month < 12 && day > 10) {
  month = month;
} else {
  month = month;
  n = n;

}

console.log("month", month);

const month_name = (dt) => {
  var mlist = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  return mlist[dt];
}

const monthState = {
  monthYear: {
    month: month,
    year: n,
    day: day,
    monthName: month_name(month)
  }
};

console.log('monthName', monthState);

export default function(state = monthState, action) {
  switch (action.type) {
    case SET_MONTH_YEAR:
      return {
        ...state,
        monthYear: action.payload
      };
    case RESET_MONTH:
      return {
        ...state,
        monthYear: {
          month: month,
          year: n,
          day: day,
          monthName: month_name(month)
        }
      };

    default:
      return state;
  }
}
